/* eslint-disable react/no-direct-mutation-state */
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { pipe } from "../../utilities/fp.js";
import { MarkdownContent } from "../../shared/MarkdownContent/MarkdownContent.js";
import {
  getProcedureNotes,
  saveProcedureNote,
  deleteProcedureNote,
  getAProcedureNote,
} from "../../Actions/ProcedureNotes/proNotesActions.js";
import {
  getUser,
  checkIfPermissionAllowed,
  showFormattedDate,
  displayName,
} from "../../Utils/services.js";
import "react-tagsinput/react-tagsinput.css";
import AcknowledgeHistoryModal from "../ClientNotes/AcknowledgeHistoryModal.js";
import { PatternAutocomplete } from "../../widgets/PatternAutocomplete/PatternAutocomplete.js";
import { uiNotification } from "../../services/UINotificationService.js";
import { Dictation } from "../../widgets/Dictation/Dictation.js";
import { AppTranslation } from "../../i18n/useAppTranslation.js";
import { GENDERS, USER_ROLE_NAMES } from "../../consts/api.js";
import { withCurrentUserQuery } from "../../api/queries/useUserQuery.js";
import { TextModeToggle } from "../../boxes/TextModeToggle/index.js";

const prepareDotPhrases = (dotPhrasesList = []) => {
  return dotPhrasesList.map((i) => ({
    label: i.name,
    description: i?.title || null,
    value: i.phrase,
  }));
};

const prepareMedicalHistory = (medicalHistoryList = []) => {
  return medicalHistoryList.map((i) => ({
    label: i.title,
    value: `${i.title}: ${i.value}`,
    description: i.value,
  }));
};

class ProcedureNotes extends Component {
  constructor(props) {
    super(props);

    this.escFunction = this.escFunction.bind(this);
    const languageData = JSON.parse(localStorage.getItem("languageData"));

    this.state = {
      subAction: this.props?.history?.location?.state?.subAction,

      action:
        this.props.match.params.type !== null &&
        this.props.match.params.type !== "" &&
        this.props.match.params.type
          ? this.props.match.params.type
          : "",
      procedureID:
        this.props.match.params.procedureID !== null &&
        this.props.match.params.procedureID !== "" &&
        this.props.match.params.procedureID
          ? this.props.match.params.procedureID
          : 0,
      patientID:
        this.props.match.params.patientID !== null &&
        this.props.match.params.patientID !== "" &&
        this.props.match.params.patientID
          ? this.props.match.params.patientID
          : 0,
      showLoader: false,
      procedureNotes: [],
      patientData: [],
      procedureNote: [],
      showModal: false,
      dataChanged: false,
      noteText: "",
      noteClass: "setting-textarea-box",
      tags: [],
      noteTobeDeleted: 0,
      noteTobeEdited: 0,
      roomType: this.props.match.url.split("/")[1],
      languageData: languageData.procedure,
      globalLang: languageData.global,
      editNoteID: this.props.match.params.noteID
        ? this.props.match.params.noteID
        : 0,
      showSearchResult: false,
      roomTypeParams:
        this.props.match.params.roomType !== null &&
        this.props.match.params.roomType !== "" &&
        this.props.match.params.roomType
          ? this.props.match.params.roomType
          : "",
      autoCompleteType: "",
      autoCompleteTerm: "",
      autoCompleteList: [],
      acknowledgeHistoryModalStatus: false,
      notesId: "",
    };

    window.onscroll = () => {
      return false;
    };

    this.containerRef = React.createRef();
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.setState({ showSearchResult: false });
    }
  }

  fetchNotes = () => {
    this.setState({ showLoader: true });
    this.showLoaderFunc();

    this.props
      .getProcedureNotes({
        params: {
          patient_id: this.state.patientID,
          procedure_id: this.state.procedureID,
          note_id: this.state.editNoteID,
        },
      })
      .then((res) => {
        if (
          [
            "validation_patient_id_exists",
            "validation_procedure_id_exists",
          ].includes(res.message)
        ) {
          setTimeout(function () {
            window.location.href = "/clients";
          }, 1700);
        }

        this.setState({
          procedureNotes: res.data?.procedure_notes || [],
          patientData: res.data?.patient_detail || {},
          dotPhrasesList: prepareDotPhrases(res.data?.dot_phrases_list || []),
          medicalHistoryList: prepareMedicalHistory(
            res.data?.medical_history || [],
          ),
        });

        if (
          this.state.editNoteID > 0 &&
          checkIfPermissionAllowed("add-edit-procedure-notes")
        ) {
          if (res.data.procedure_note) {
            this.setState({ noteTobeEdited: this.state.editNoteID });
          }
        }
      })
      .catch((res) => {
        uiNotification.error(
          this.state.globalLang[res.message] || "Unable To Retrieve Notes",
        );
      })
      .finally(() => {
        this.setState({ showLoader: false });
      });
  };

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
    this.fetchNotes();
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  showLoaderFunc = () => {
    this.setState({ showLoader: true });
    localStorage.setItem("showLoader", true);
  };

  static getDerivedStateFromProps(props, state) {
    if (
      props.procedureNote !== undefined &&
      props.procedureNote.status === 200 &&
      props.procedureNote.data &&
      props.procedureNote.data !== state.procedureNote.data &&
      state.noteTobeEdited > 0
    ) {
      let hashtags =
        props.procedureNote.data.hashtags &&
        props.procedureNote.data.hashtags !== undefined &&
        props.procedureNote.data.hashtags !== "" &&
        props.procedureNote.data.hashtags !== null
          ? props.procedureNote.data.hashtags.split(",")
          : "";

      if (localStorage.getItem("showLoader") == "false") {
        return {
          procedureNote: props.procedureNote.data,
          showLoader: false,
          tags: state.dataChanged ? state.tags : hashtags,
        };
      }
    } else if (
      props.procedureNote !== undefined &&
      props.procedureNote.status !== 200 &&
      props.procedureNote.data &&
      props.procedureNote.data !== state.procedureNote.data &&
      state.noteTobeEdited > 0
    ) {
      if (localStorage.getItem("showLoader") == "false") {
        return {
          procedureNote: props.procedureNote.data,
          showLoader: false,
          noteTobeEdited: 0,
        };
      }
    }

    return null;
  }

  getLoggedInUserData = () => {
    let userData = JSON.parse(getUser());

    if (userData) {
      return userData.user.id;
    }

    return 0;
  };

  showDeleteModal = (obj) => {
    this.state.noteTobeDeleted = obj.id;
    this.setState({
      showModal: true,
      showSearchResult: false,
      dataChanged: false,
      noteTobeDeleted: obj.id,
    });
  };

  editThisNote = (e) => {
    e.preventDefault();
    this.state.noteTobeEdited = e.target.name;
    this.showLoaderFunc();

    if (this.state.noteTobeEdited > 0) {
      this.setState({ showSearchResult: false, dataChanged: false });
      this.props
        .getAProcedureNote(this.state.noteTobeEdited)
        .catch((res) => {
          uiNotification.error(
            this.state.globalLang[res.message] || "Unable To Retrieve Note",
          );
        })
        .then((res) => {
          this.setState({
            noteText: res.data.notes || "",
          });
          this.containerRef.current.scrollIntoView({ behavior: "smooth" });
        })
        .finally(() => {
          this.setState({ showLoader: false });
        });
    }
  };

  dismissDeleteModal = () => {
    this.state.noteTobeDeleted = 0;
    this.setState({ showModal: false, noteTobeDeleted: 0 });
  };

  deleteNote = () => {
    let noteID = this.state.noteTobeDeleted;

    this.props.history.push(
      `/${this.state.roomType}/notes/${this.state.procedureID}/${this.state.patientID}/${this.state.action}`,
    );

    if (noteID > 0) {
      this.showLoaderFunc();
      this.setState({
        tags: [],
        dataChanged: false,
        procedureNote: [],
        noteClass: "setting-textarea-box",
        showLoader: true,
        showModal: false,
        noteTobeDeleted: noteID,
      });

      this.props
        .deleteProcedureNote(noteID)
        .then((res) => {
          uiNotification.success(
            this.state.globalLang[res.message] ||
              "Note Has Been Successfully Deleted",
          );
          this.fetchNotes();
        })
        .catch((res) => {
          uiNotification.error(
            this.state.globalLang[res.message] || "Unable To Delete Note",
          );
        });

      this.state.procedureNote = [];
      this.state.tags = [];
      this.state.noteText = "";
    } else {
      uiNotification.error("Can not delete this note at this time");
    }
  };

  onSaveProcedureNotes = (createNew = false) => {
    let formData = {
      patient_id: this.state.patientID,
      procedure_id: this.state.procedureID,
      notes: this.state.noteText,
    };

    if (this.state.tags?.length > 0) {
      formData.tags = this.state.tags;
    }

    this.props
      .saveProcedureNote(formData, createNew ? 0 : this.state.noteTobeEdited)
      .then((res) => {
        uiNotification.success(
          this.state.globalLang[res.message] || "Note Successfully Saved",
        );
        this.fetchNotes();
      })
      .catch((res) => {
        uiNotification.error(
          this.state.globalLang[res.message] || "Unable To Save Note",
        );
      })
      .finally(() => {
        this.setState({ showLoader: false });
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    if (
      typeof this.state.noteText === undefined ||
      this.state.noteText === null ||
      this.state.noteText === ""
    ) {
      this.setState({
        noteClass: "setting-textarea-box setting-input-box-invalid",
      });
    } else if (this.state.noteText) {
      this.showLoaderFunc();
      this.setState({
        noteClass: "setting-textarea-box",
      });

      this.onSaveProcedureNotes();

      this.state.procedureNote = [];
      this.state.tags = [];
      this.state.noteText = "";

      this.setState({
        tags: [],
        dataChanged: false,
        procedureNote: [],
        noteText: "",
        noteTobeEdited: 0,
        editNoteID: 0,
      });
    }
  };

  cancelEditing = (event) => {
    event.preventDefault();

    this.setState({
      tags: [],
      dataChanged: false,
      procedureNote: [],
      noteText: "",
      noteTobeEdited: 0,
      noteClass: "setting-textarea-box",
    });
  };

  toggleAcknowledgementHistoryModal = (id) => {
    this.setState((prevState) => ({
      acknowledgeHistoryModalStatus: !prevState.acknowledgeHistoryModalStatus,
      notesId: !prevState.acknowledgeHistoryModalStatus ? id : "",
    }));
  };

  getIcon = (image, gender) => {
    if (image) {
      return image;
    }

    switch (gender) {
      case GENDERS.female:
        return "/images/appfemale.png";
      case GENDERS.male:
        return "/images/appmale.png";
      default:
        return "/images/appmale.png";
    }
  };

  get isMd() {
    return (
      this.props.currentUserQuery?.data?.role ===
      USER_ROLE_NAMES.medicalDirector
    );
  }

  render() {
    let returnUrl = "";
    if (this.state.roomType && this.state.roomType === "clients") {
      returnUrl = this.props.match.params.type
        ? "/" +
          this.state.roomType +
          "/" +
          this.props.match.params.type +
          "/" +
          this.props.match.params.patientID
        : "/" + this.state.roomType;
    } else if (
      this.state.roomTypeParams &&
      (this.state.roomTypeParams === "provider-room" ||
        this.state.roomTypeParams === "md-room")
    ) {
      returnUrl = `/${this.state.roomTypeParams}/${this.state.action}`;
    } else {
      returnUrl =
        this.state.action !== ""
          ? `/${this.state.roomType}/${this.props.location.state?.procedureRoomType}/` +
            this.state.procedureID +
            `/` +
            this.state.action
          : "";
    }

    if (this.state.subAction) {
      const sub_action = `sub_action=${this.state.subAction}`;
      if (returnUrl?.includes("?")) {
        returnUrl += `&${sub_action}`;
      } else {
        returnUrl += `?${sub_action}`;
      }
    }

    let noteTimelineClass =
      this.state.procedureNotes && this.state.procedureNotes.length > 0
        ? "note-timeline"
        : "note-timeline no-display";

    let noRecordClass =
      this.state.procedureNotes && this.state.procedureNotes.length > 0
        ? "no-record no-display"
        : "no-record";

    let firstname =
      this.state.patientData && this.state.patientData.firstname
        ? this.state.patientData.firstname
        : "";

    let lastname =
      this.state.patientData && this.state.patientData.lastname
        ? this.state.patientData.lastname
        : "";

    let patientName = firstname + " " + lastname;

    return (
      <div id="content">
        <div className="wide-popup">
          <div className="modal-blue-header">
            <Link to={returnUrl} className="popup-cross">
              ×
            </Link>
            {this.state.showLoader === false && (
              <span className="popup-blue-name">
                {patientName +
                  ` - ${this.state.languageData.pro_head_pro_notes_text}`}
              </span>
            )}
          </div>
          <div
            ref={this.containerRef}
            className="wide-popup-wrapper time-line procedure-notes-container"
          >
            {checkIfPermissionAllowed("add-edit-procedure-notes") === true &&
              (this.state.roomTypeParams !== "md-room" ||
                this.state.roomType !== "md-room" ||
                this.isMd) && (
                <div>
                  <div className="add-note-label">
                    {this.state.languageData.pro_add_note_text}
                  </div>
                  <Dictation
                    value={this.state.noteText || ""}
                    onChange={(next) => {
                      this.setState({ noteText: next });
                    }}
                    onSaveNote={() => this.onSaveProcedureNotes(true)}
                  />
                  <div className="row">
                    <div className="col-xs-12">
                      <form
                        id="add-notes"
                        name="ar-add-notes-form"
                        className="nobottommargin"
                        action="#"
                        method="post"
                      >
                        <div className="row">
                          <div className="col-xs-12">
                            <div className="setting-field-outer relative">
                              <div className="new-field-label">
                                {this.state.languageData.pro_note_text}{" "}
                                <span className="setting-require">*</span>
                              </div>
                              <div className="col-12">
                                <TextModeToggle
                                  toggleOnPreviewClick
                                  renderPreviewMode={() => (
                                    <MarkdownContent>
                                      {this.state.noteText}
                                    </MarkdownContent>
                                  )}
                                  renderEditMode={() => (
                                    <PatternAutocomplete
                                      focusOnMount
                                      value={this.state.noteText || ""}
                                      onChange={(next) => {
                                        this.setState({ noteText: next });
                                      }}
                                      placeholder="Type your notes and hashtags here"
                                      patterns={[
                                        {
                                          match: ".",
                                          substitutes:
                                            this.state.dotPhrasesList,
                                        },
                                        {
                                          match: "@call",
                                          substitutes:
                                            this.state.medicalHistoryList,
                                        },
                                      ]}
                                    />
                                  )}
                                />
                                <div className="m-t-5 maxCharacterInstruction">
                                  <AppTranslation.Clients path="createEditHealthProcedure.notes.dotPhrasesDesc" />
                                </div>
                                <p className="m-t-5 maxCharacterInstruction">
                                  <AppTranslation.Clients path="createEditHealthProcedure.notes.callFuncDesc" />
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-xs-12">
                            <div className="button-group">
                              <button
                                onClick={this.handleSubmit}
                                className="save-button"
                                type="submit"
                                id="save-profile"
                              >
                                {this.state.languageData.pro_save_btn_text}
                              </button>
                              {this.state.noteTobeEdited &&
                              this.state.noteTobeEdited > 0 ? (
                                <button
                                  onClick={this.cancelEditing}
                                  className="cancel-button"
                                  type="button"
                                >
                                  Cancel
                                </button>
                              ) : (
                                <button
                                  onClick={() =>
                                    this.setState({ noteText: "" })
                                  }
                                  className="cancel-button"
                                  type="button"
                                >
                                  Clear
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}

            <div
              className={this.state.showModal === true ? "overlay" : ""}
            ></div>
            <div
              id="filterModal"
              role="dialog"
              className={
                this.state.showModal === true
                  ? "modal fade in displayBlock"
                  : "modal fade no-display"
              }
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      onClick={this.dismissDeleteModal}
                    >
                      ×
                    </button>
                    <h4 className="modal-title" id="model_title">
                      {this.state.languageData.pro_delete_confirmation_text}
                    </h4>
                  </div>
                  <div
                    id="errorwindow"
                    className="modal-body add-patient-form filter-patient"
                  >
                    {this.state.languageData.pro_are_you_sure_text}
                  </div>
                  <div className="modal-footer">
                    <div className="col-md-12 text-left" id="footer-btn">
                      <button
                        type="button"
                        className="btn  logout pull-right"
                        data-dismiss="modal"
                        onClick={this.dismissDeleteModal}
                      >
                        {this.state.languageData.pro_no_text}
                      </button>
                      <button
                        type="button"
                        className="btn btn-success pull-right m-r-10"
                        data-dismiss="modal"
                        onClick={this.deleteNote}
                      >
                        {this.state.languageData.pro_yes_text}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {this.state.showLoader === false && (
              <div className={noRecordClass}>
                {this.state.languageData.pro_no_notes_text}
              </div>
            )}
            {this.state.showLoader === true &&
              this.state.noteTobeEdited === 0 && (
                <div className="no-record">
                  {this.state.languageData.pro_loading_dot}
                </div>
              )}

            <div className={noteTimelineClass}>
              {checkIfPermissionAllowed("view-procedure-notes") &&
                this.state.procedureNotes.map((noteobj, noteidx) => {
                  return (
                    <div id={noteobj.id} className="row" key={noteidx}>
                      <span className="sticky-note-image">
                        <img
                          alt="sticky-note"
                          src={this.getIcon(
                            noteobj.user?.user_image_url,
                            noteobj.user?.gender,
                          )}
                        />
                      </span>
                      <div className="col-sm-4 col-xs-12 col-md-3 note-subject">
                        <h4 className="note-title">
                          {noteobj.user !== null
                            ? displayName(noteobj.user)
                            : "Deleted User"}{" "}
                          {this.state.languageData.pro_left_a_note_text}
                        </h4>
                        <p>{showFormattedDate(noteobj.created, true)}</p>
                      </div>
                      <div
                        className="col-sm-6 col-xs-12 col-md-6"
                        id="note-content"
                      >
                        <div className="note-content">
                          <MarkdownContent>{noteobj.notes}</MarkdownContent>
                          <br />
                          {noteobj.hashtags &&
                            noteobj.hashtags
                              .split(",")
                              .map((hashObj, hashIdx) => {
                                return (
                                  <span key={hashIdx} className="hashTag">
                                    {hashObj}{" "}
                                  </span>
                                );
                              })}
                        </div>
                        <textarea className="no-display" defaultValue="" />
                      </div>
                      {noteobj.user !== null && (
                        <div className="col-sm-2 col-xs-12 col-md-3 no-padding">
                          <button
                            id="copy-note"
                            className="easy-link"
                            onClick={() => {
                              const textToCopy = noteobj?.notes?.trim() || "";
                              navigator.clipboard.writeText(textToCopy);
                              uiNotification.success(
                                "Note copied to clipboard",
                              );
                            }}
                          >
                            Copy
                          </button>

                          {checkIfPermissionAllowed(
                            "add-edit-procedure-notes",
                          ) &&
                          (this.getLoggedInUserData() === noteobj.user.id ||
                            noteobj.user.id ==
                              process.env.REACT_APP_SUPERUSER) &&
                          (this.state.roomTypeParams !== "md-room" ||
                            this.state.roomType !== "md-room") ? (
                            <button
                              id="edit-note"
                              className="easy-link"
                              name={noteobj.id}
                              onClick={this.editThisNote.bind(this)}
                            >
                              {this.state.languageData.pro_edit_btn_text}
                            </button>
                          ) : (
                            ""
                          )}
                          {checkIfPermissionAllowed(
                            "add-edit-procedure-notes",
                          ) ||
                          checkIfPermissionAllowed("view-procedure-notes") ||
                          (noteobj.user.id == process.env.REACT_APP_SUPERUSER &&
                            (this.state.roomTypeParams !== "md-room" ||
                              this.state.roomType !== "md-room")) ? (
                            <button
                              id="edit-note"
                              className="easy-link"
                              name={noteobj.id}
                              onClick={() =>
                                this.toggleAcknowledgementHistoryModal(
                                  noteobj.id,
                                )
                              }
                            >
                              Note History
                            </button>
                          ) : (
                            ""
                          )}

                          {checkIfPermissionAllowed(
                            "add-edit-procedure-notes",
                          ) &&
                          (this.getLoggedInUserData() === noteobj.user.id ||
                            noteobj.user.id ==
                              process.env.REACT_APP_SUPERUSER) &&
                          (this.state.roomTypeParams !== "md-room" ||
                            this.state.roomType !== "md-room") ? (
                            <button
                              id="delete-note"
                              className="easy-link"
                              name={noteobj.id}
                              onClick={() => this.showDeleteModal(noteobj)}
                            >
                              {this.state.languageData.pro_del_btn_text}
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
          <div
            className={
              this.state.showLoader
                ? "new-loader text-left displayBlock"
                : "new-loader text-left"
            }
          >
            <div className="loader-outer">
              <img
                alt=""
                id="loader-outer"
                src="/images/Eclipse.gif"
                className="loader-img"
              />
              <div id="modal-confirm-text" className="popup-subtitle">
                {this.state.globalLang.Please_Wait}
              </div>
            </div>
          </div>
        </div>
        {this.state.acknowledgeHistoryModalStatus && (
          <AcknowledgeHistoryModal
            id={this.state.notesId}
            onClose={this.toggleAcknowledgementHistoryModal}
            isAcknowledgeHistorOrNotesHistory={
              !this.state.acknowledgeHistoryModalStatus
            }
            noteType="procedure-note"
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  localStorage.setItem("showLoader", false);

  if (state.ProcedureNotesReducer.action === "GET_PROCEDURE_NOTE") {
    return {
      procedureNote: state.ProcedureNotesReducer.data,
    };
  }

  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getProcedureNotes,
      saveProcedureNote,
      deleteProcedureNote,
      getAProcedureNote,
    },
    dispatch,
  );
}

export default pipe(
  ProcedureNotes,
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withCurrentUserQuery,
);
